export default __webpack_public_path__ + "static/article-latitude-real-accounts-shivani-c8a6e22f1b82fa002d6c5f095f2b97d3.jpg";